'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.default = UploadFileButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _upload = require('../icons/upload');

var _upload2 = _interopRequireDefault(_upload);

var _utils = require('../../../libs/utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function UploadFileButton(_ref) {
  var onChange = _ref.onChange;

  var _useState = (0, _react.useState)((0, _utils.uniqueId)('upload-file-input')),
      _useState2 = _slicedToArray(_useState, 1),
      uploadFileInputId = _useState2[0];

  return _react2.default.createElement('label', {
    className: 'rainbow-import-records-flow_step-two_upload-file-label',
    htmlFor: uploadFileInputId
  }, _react2.default.createElement('input', {
    id: uploadFileInputId,
    className: 'rainbow-import-records-flow_step-two_upload-file-input',
    type: 'file',
    accept: 'text/csv',
    multiple: false,
    onChange: onChange
  }), _react2.default.createElement(_upload2.default, {
    className: 'rainbow-import-records-flow_step-two-upload-button-icon'
  }), 'Upload CSV File');
}

UploadFileButton.propTypes = {
  onChange: _propTypes2.default.func.isRequired
};